import { defineFcm } from '../shared/factory';

export const FCM_GDPR_SIGN_OPT_IN = defineFcm('gdpr_sign_opt_in').asBoolean().withDefault(false).toConfig();
